import Icon from 'veui/components/Icon'

Icon.register({
  'gender-female': {
    paths: [
      {
        d: 'M651.65 116.35A288 288 0 00223 499.77l-47 47-57.37-57.38a32 32 0 00-45.26 45.26L130.75 592l-57.38 57.37a32 32 0 0045.26 45.26L176 637.25l57.37 57.38a32 32 0 0045.26-45.26L221.25 592l47-47a288 288 0 00383.4-428.65zm-45.26 362A224 224 0 11672 320a222.53 222.53 0 01-65.61 158.39z'
      }
    ],
    width: '768',
    height: '768'
  }
})
